import useOrganization from './api/useOrganization';

export type UseIsPublicOrgMissingInfoReturnValue = {
    isMissingInfo: boolean | 'loading';
};

/**
 * Hook to check if the public organization is missing information.
 *
 * If the org is public, it should have publicly available information (logo).  This is not a strict requirement, but
 * should notify the user that they should add this information.
 */
export const useIsPublicOrgMissingInfo = (): UseIsPublicOrgMissingInfoReturnValue => {
    const organizationHookRes = useOrganization({});

    if (organizationHookRes.isLoadingMyOrganization || organizationHookRes.isLoadingHasOrganizationLogo) {
        return { isMissingInfo: 'loading' };
    } else {
        return {
            isMissingInfo:
                !!organizationHookRes.myOrganization?.organization.isPubliclyListed &&
                !organizationHookRes.hasOrganizationLogo,
        };
    }
};
